import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntFieldBoxComponent} from "./int-field-box.component";

@NgModule({
  imports: [CommonModule],
  declarations: [IntFieldBoxComponent],
  exports: [IntFieldBoxComponent]
})
export class IntFieldBoxModule {}
